var map = {
	"./arrow.svg": 58818,
	"./bug.svg": 59376,
	"./circle-chart.svg": 49856,
	"./contact.svg": 62156,
	"./directory.svg": 96087,
	"./envelope.svg": 48506,
	"./help.svg": 34070,
	"./home.svg": 93898,
	"./humburger-menu.svg": 2645,
	"./informations.svg": 25339,
	"./logout.svg": 70191,
	"./message-sms.svg": 85354,
	"./message.svg": 51055,
	"./news.svg": 30782,
	"./phone.svg": 20811,
	"./posiedzenia.svg": 7494,
	"./question.svg": 73597,
	"./rejestr.svg": 879,
	"./save.svg": 15578,
	"./server-white.svg": 69002,
	"./server.svg": 62268,
	"./show-all.svg": 84881,
	"./sms.svg": 15368,
	"./szablon-posiedzenia.svg": 60516,
	"./user_activiti.svg": 79925,
	"./users.svg": 18646
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78332;